import React from 'react';
import { FaBed, FaBath, FaRulerCombined, FaMapMarkerAlt } from 'react-icons/fa';
import './Properties.css';

const Properties = () => {
  const properties = [
    {
      id: 1,
      type: 'Apartment',
      title: '2 BHK Spacious Apartment',
      location: 'Vasai West, Mumbai',
      price: '₹65 Lakhs',
      beds: 2,
      baths: 2,
      area: '850 sq.ft',
      image: 'https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?w=800'
    },
    {
      id: 2,
      type: 'Villa',
      title: '3 BHK Luxury Villa',
      location: 'Vasai West, Mumbai',
      price: '₹1.2 Cr',
      beds: 3,
      baths: 3,
      area: '1500 sq.ft',
      image: 'https://images.unsplash.com/photo-1600596542815-ffad4c1539a9?w=800'
    },
    {
      id: 3,
      type: 'Office',
      title: 'Commercial Office Space',
      location: 'Vasai West, Mumbai',
      price: '₹45 Lakhs',
      beds: 0,
      baths: 2,
      area: '1200 sq.ft',
      image: 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=800'
    },
    {
      id: 4,
      type: 'Apartment',
      title: '1 BHK Modern Flat',
      location: 'Vasai West, Mumbai',
      price: '₹42 Lakhs',
      beds: 1,
      baths: 1,
      area: '600 sq.ft',
      image: 'https://images.unsplash.com/photo-1502672260266-1c1ef2d93688?w=800'
    },
    {
      id: 5,
      type: 'Apartment',
      title: '3 BHK Premium Apartment',
      location: 'Vasai West, Mumbai',
      price: '₹95 Lakhs',
      beds: 3,
      baths: 2,
      area: '1100 sq.ft',
      image: 'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?w=800'
    },
    {
      id: 6,
      type: 'Shop',
      title: 'Retail Shop Space',
      location: 'Vasai West, Mumbai',
      price: '₹35 Lakhs',
      beds: 0,
      baths: 1,
      area: '800 sq.ft',
      image: 'https://images.unsplash.com/photo-1441986300917-64674bd600d8?w=800'
    }
  ];

  return (
    <section className="properties section-padding" id="properties">
      <div className="container">
        <div className="section-title">
          <h2>Featured Properties</h2>
          <p>Explore Our Handpicked Selection of Premium Properties</p>
        </div>

        <div className="properties-grid">
          {properties.map((property) => (
            <div className="property-card" key={property.id}>
              <div className="property-image">
                <img src={property.image} alt={property.title} />
                <div className="property-type">{property.type}</div>
              </div>
              <div className="property-info">
                <h3>{property.title}</h3>
                <p className="property-location">
                  <FaMapMarkerAlt /> {property.location}
                </p>
                <div className="property-features">
                  {property.beds > 0 && (
                    <span><FaBed /> {property.beds} Beds</span>
                  )}
                  <span><FaBath /> {property.baths} Baths</span>
                  <span><FaRulerCombined /> {property.area}</span>
                </div>
                <div className="property-footer">
                  <div className="property-price">{property.price}</div>
                  <button className="btn-view">View Details</button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Properties;